import React, { useState, useEffect } from 'react';
import { updateCategoria } from '../../../api/categorias';
import { Button, TextField, Box, CircularProgress } from '@mui/material';

const EditCategoria = React.memo(({ categoria, onClose }: any) => {
  const [formData, setFormData] = useState(categoria);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    Ct_Nombre: '',
  });

  useEffect(() => {
    setFormData(categoria);
  }, [categoria]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    let tempErrors = { Ct_Nombre: '' };
    if (!formData.Ct_Nombre) tempErrors.Ct_Nombre = 'El nombre es requerido';
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === '');
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    await updateCategoria(formData.Ct_Id, formData);
    setLoading(false);
    onClose();
  };

  return (
    <div>
      <form>
        <TextField label='Nombre' name='Ct_Nombre' value={formData.Ct_Nombre} onChange={handleChange} fullWidth required sx={{ marginBottom: '0.8rem', marginTop: '1rem' }} size='small' error={!!errors.Ct_Nombre} helperText={errors.Ct_Nombre} />
        <Box display='flex' justifyContent='space-between'>
          <Button onClick={handleSubmit} variant='outlined' size='small' disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Actualizar'}
          </Button>
          <Button onClick={onClose} variant='outlined' color='error' size='small'>
            Cancelar
          </Button>
        </Box>
      </form>
    </div>
  );
});

export default EditCategoria;
    